import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import isScrollLocked from '../Dialog/isScrollLocked';
import BowtieSpinner from './BowtieSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles({
  container: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    '& > $paper': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
  paper: {}
});
const DialogSpinner = props => {
  const classes = useStyles();
  return _jsx(Dialog, {
    classes: {
      container: classes.container,
      paper: classes.paper
    },
    hideBackdrop: true,
    disableScrollLock: isScrollLocked(),
    ...props,
    children: _jsx(BowtieSpinner, {})
  });
};
export default DialogSpinner;